import { Indicator } from "@mantine/core";
import { PropsWithChildren } from "react";

import { colors } from "#app/theme/v1/colors";
import { spacing } from "#app/theme/v1/spacing";
import { useCompany } from "#modules/company/view/useCompany";
import { Box } from "#shared/view/components/Box";
import { FEATURES_TYPE } from "#types/FeatureToggleTypes";

export const useIsFeatureEnabled = (feature: FEATURES_TYPE, isBetaFeature = false): boolean => {
  const { company } = useCompany();

  if (isBetaFeature && company?.companySettings.isBetaTester) {
    return true;
  }

  return import.meta.env[`VITE_FF_${feature}`] === "true";
};

export const FeatureToggle = ({
  feature,
  children,
  isBetaFeature = false,
}: PropsWithChildren<{
  feature: FEATURES_TYPE;
  isBetaFeature?: boolean;
}>) => {
  const enabled = useIsFeatureEnabled(feature, isBetaFeature);

  if (!enabled) {
    return null;
  }

  if (import.meta.env.VITE_ENV !== "production") {
    return (
      <Indicator size={15} color="red">
        <Box style={styles}>{children}</Box>
      </Indicator>
    );
  }

  return children;
};

const styles = {
  border: "2px dashed",
  borderColor: colors.red[1],
  padding: spacing.xxxs,
};
